import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconFish({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 28 28"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g
				fill="none"
				fillRule="evenodd"
				style={{
					transform: "translateX(2px) translateY(2px)",
				}}
			>
				<path
					fill="#CD0400"
					d="M21.408 0a.427.427 0 0 0-.427.427v6.678a.427.427 0 1 0 .854 0V.427A.427.427 0 0 0 21.408 0m-7.934 5.013a.66.66 0 1 0 0 1.32.66.66 0 0 0 0-1.32"
				/>
				<path
					fill="#FFF"
					d="M10.053 9.686c-5.94 3.044-5.435 6.94-5.41 7.105a.424.424 0 0 0 .481.358.43.43 0 0 0 .363-.48c-.02-.142-.405-3.477 4.955-6.224a.427.427 0 1 0-.389-.76"
				/>
				<path
					fill="#FFF"
					d="M14.972 9.164c-.022.002-.044-.003-.066.003-1.829.456-2.99-2.203-3.002-2.23a.426.426 0 0 0-.785.334c.047.111.974 2.237 2.671 2.71-.224.14-.458.283-.711.43-.706.413-1.395.831-2.044 1.267-.026.011-.047.029-.07.046-3.245 2.19-5.467 4.812-3.823 9.26-1.342-.957-2.629-2.378-3.442-4.493-.95-2.467-.479-4.878 1.399-7.167 1.838-2.24 4.378-3.577 5.112-3.933 2.073-1.005 4.186-1.345 5.545-1.265-.96 1.84-.807 2.08-.69 2.256.178.267.571.335 1.374.45.145.02.327.048.481.075-.428.843-1.02 1.54-1.949 2.257m-5.47 6.527c-.153-.33-.338-.815-.49-1.274.408-.44.88-.858 1.405-1.262-.337 1.023-.683 1.995-.915 2.536m-.559 3.61c.469-.105 1.016-.328 1.545-.543.294-.12.708-.288 1.033-.39-.124.143-.263.297-.382.43-1.054 1.168-1.499 1.731-1.331 2.225.108.32.498.631 1.177 1.155.233.18.587.453.847.689a11.4 11.4 0 0 1-3.436-1.118c-.478-.99-.769-1.882-.89-2.694.371.236.854.376 1.437.246M6.612 6.67A14.6 14.6 0 0 0 4.63 8.56c-.607-.33-1.247-.721-1.577-.98.684-.312 2.355-.823 3.559-.91m11.245-.143c-.08-.362-.531-.43-1.295-.54a12 12 0 0 1-.673-.11c.145-.406.543-1.224.912-1.898.011-.02.012-.042.02-.063.007-.021.02-.04.025-.062v-.019c.004-.03 0-.058-.001-.088-.002-.026-.001-.052-.007-.077q-.012-.038-.032-.073-.015-.038-.038-.074c-.014-.02-.035-.035-.053-.053-.022-.02-.043-.042-.07-.058q-.006-.006-.013-.012c-.021-.011-.043-.012-.065-.02-.02-.007-.038-.02-.06-.025-1.45-.275-4.076.01-6.668 1.267-.374.182-1.194.607-2.159 1.263-1.571-.353-5.313.77-5.612 1.399-.13.272-.317.679 2.018 1.952-1.761 2.386-2.172 4.989-1.183 7.56 1.109 2.882 3.03 4.578 4.865 5.576.067.076.159.12.256.135 2.323 1.19 4.436 1.287 4.475 1.288l.174.006.129-.118a.64.64 0 0 0 .21-.503c-.022-.51-.587-.97-1.506-1.678-.299-.23-.736-.569-.863-.718.116-.293.769-1.016 1.129-1.416.768-.851 1.055-1.17.874-1.543-.35-.724-1.336-.323-2.48.142-.496.202-1.01.41-1.41.5-.828.189-1.24-.582-1.285-.672q-.01-.014-.02-.026c.07-.962.4-1.803.928-2.567.517 1.439.86 1.668 1.109 1.668.062 0 .118-.015.17-.028.237-.06.56-.143 1.918-4.507a43 43 0 0 1 1.933-1.188c2.453-1.433 3.636-2.587 4.365-4.259a.42.42 0 0 0-.017-.361"
				/>
				<path
					fill="#FFF"
					d="M21.408 9.171h-.003a.656.656 0 0 1-.657-.663.66.66 0 0 1 .66-.657h.004a.661.661 0 0 1-.004 1.32m.007-2.173h-.007a1.516 1.516 0 0 0-1.076 2.578c.19.193.426.321.68.39v3.277c-.003.021-.013.04-.013.063a1.89 1.89 0 0 1-1.897 1.87h-.01a1.88 1.88 0 0 1-1.87-1.89l.005-.903 1.07.811a.425.425 0 0 0 .599-.082.427.427 0 0 0-.083-.598l-1.75-1.326c-.014-.01-.03-.013-.045-.022a.4.4 0 0 0-.164-.055c-.016-.002-.03-.01-.047-.01h-.002c-.01 0-.018.005-.027.006a.4.4 0 0 0-.089.017 1 1 0 0 0-.071.025.4.4 0 0 0-.067.045.4.4 0 0 0-.064.057q-.012.008-.022.02c-.01.013-.013.03-.022.044a.5.5 0 0 0-.038.078.4.4 0 0 0-.017.084c-.002.017-.01.031-.01.049l-.009 1.756a2.737 2.737 0 0 0 2.719 2.747h.014a2.745 2.745 0 0 0 2.75-2.719c0-.023-.008-.043-.012-.066v-3.29a1.51 1.51 0 0 0 1.082-1.435 1.516 1.516 0 0 0-1.507-1.521"
				/>
			</g>
		</svg>
	);
}
